import { EmailContentComponent } from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/types'
import { EmailContentType } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

import { EmailContentAttachmentComponent } from './EmailContentAttachment/EmailContentAttachment'
import { EmailContentButtonComponent } from './EmailContentButton/EmailContentButton'
import { EmailContentPreviewComponent } from './EmailContentPreview/EmailContentPreview'
import { EmailContentTextComponent } from './EmailContentText/EmailContentText'

export const EmailContentMapping: Partial<Record<EmailContentType, EmailContentComponent>> = {
  [EmailContentType.TEXT]: EmailContentTextComponent as EmailContentComponent,
  [EmailContentType.PREVIEW]: EmailContentPreviewComponent as EmailContentComponent,
  [EmailContentType.ATTACHMENT]: EmailContentAttachmentComponent as EmailContentComponent,
  [EmailContentType.BUTTON]: EmailContentButtonComponent as EmailContentComponent,
}
